import {createFeatureSelector, createSelector, MemoizedSelector} from "@ngrx/store";
import {IdataBinding} from "@ispm-client/modules/aggregator/interfaces";
import {IdynamicFormItem} from "@ispm/dynamic-form/interfaces/IdynamicFormItem";

export const selectFormFeature = createFeatureSelector('forms');
export const selectInputConfig = createSelector(selectFormFeature, (formState: any) => formState.configs);
export const selectConfigBindings = createSelector(selectFormFeature, (formState: any) => formState.configBindings);
export const selectDataBindings = createSelector(selectFormFeature, (formState: any) => formState.dataBindings);

export const selectConfigurations = createSelector(
  selectInputConfig,
  selectConfigBindings,
  selectDataBindings
);

export const selectFormControls = (formId: string): any => {
  return createSelector(selectFormFeature, (formState: any) => formState.formControls.get(formId));
}

export const selectFormConfiguration = (formId: string): any => {
  return createSelector(
    [
      selectInputConfig,
      selectConfigBindings,
      selectDataBindings
    ],
    (inputs: Map<string, IdynamicFormItem>, configBindings: Map<string, IdataBinding[]>, dataBindings: Map<string, IdataBinding[]>) => {
      const _isFinalized = dataBindings.has(formId) && inputs.has(formId) && configBindings.has(formId);
      return !_isFinalized
        ? null
        : {
          id: formId,
          _isFinalized: _isFinalized,
          inputs: inputs.get(formId),
          dataBinding: dataBindings.get(formId) || [],
          configBindings: configBindings.get(formId) || []
        }
    });
};
